<template>
  <div class="row-content">
    <div class="row-title">
      <span>精英机构球队统计（球队总数：{{ statisticsSquadAllNum }}）</span>
    </div>
    <div class="data-wrapper">
      <template v-if="userRole === 'system' || userRole === 'admin'">
        <div
          class="select-wrapper"
          style="
          position: absolute;
          top: 10px;
          right: 15px;
          z-index: 999;
          width: 155px;
        "
        >
          <el-select
            v-model="selectYouthIndex"
            @change="youthChange"
            style="width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0)"
          >
            <el-option
              v-for="item in youthList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </template>
      <div class="echart-class-status" id="echart-pie"></div>
    </div>
  </div>
</template>

<script>
  import echarts from "echarts";
  import {debounce} from "@/assets/js/utils";
  import storage from "@/utils/storage";

  export default {
    props:{
      statisticsSquadLevel:{},
      statisticsSquadAllNum:{
        type: Number,
        required: true,
        default : 0
      },
      propsReloadTime:{
        type:Number,
        required:false,
        default:30000
      }
    },

    data(){
      return {
        loading:false,
        mapObj:null,
        pieDatakey:0,
        youthList:[], // 精英机构列表
        squadList:[], // 精英机构球队列表
        selectYouthIndex:0, // 精英机构球队统计默认精英机构选择
        youthAutoChangeTimer:null, // 精英机构默认切换
        changeTimer:null,
        userRole:storage.get("userInfo").userRole,
      };
    },

    computed:{
      echartsPieOptions(){
        let option = {
          tooltip:{
            trigger:"item",
          },
          legend:{
            bottom:10,
            left:"left",
            textStyle:{
              color:"#61A8FF",
            },
          },
          series:[
            {
              name:"精英机构球队统计",
              type:"pie",
              radius:"50%",
              bottom:"20%",
              center:["50%", "50%"],
              data:[], // 数据
              label:{
                formatter:"{b}:{c}",
                position:"top",
                show:true,
              },
              emphasis:{
                itemStyle:{
                  shadowBlur:10,
                  shadowOffsetX:0,
                  shadowColor:"rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        };
        return option;
      },
    },
    watch:{
      // 监测协会列表显示内容
      'selectYouthIndex':function(){
        this.drawClassStatus();
      }
    },

    mounted(){
      this.loadData(); // 加载数据
      this.autoChangeSelectYouthIndex(); // 自动变动
      this.drawClassStatus(); // 绘制饼状图

      if(this.mapObj){
        window.onresize = debounce(
          function(){
            this.mapObj.resize();
          },
          100,
          false
        );
      }
    },

    destroyed(){
      clearInterval(this.youthAutoChangeTimer);
    },

    methods:{
      loadData(){
        let youthData = Object.keys(this.statisticsSquadLevel); // 获取数组

        // 机构下拉框赋值
        let youthList = [];
        youthData.forEach((item, i) => {
          youthList.push({
            label:item,
            value:i
          })
        });
        this.youthList = youthList;

        // 遍历球队数组
        let squadData = [];
        for(let key in this.statisticsSquadLevel){
          squadData.push(this.statisticsSquadLevel[key]);
        }
        this.squadList = squadData;
      },

      // 手动切换培训班
      youthChange(){
        if(this.youthAutoChangeTimer) clearInterval(this.youthAutoChangeTimer);
        if(this.changeTimer) clearTimeout(this.changeTimer);

        this.changeTimer = setTimeout(() => {
          this.autoChangeSelectYouthIndex()
        })
      },

      // 切换显示当前精英机构数据 selectYouthIndex   youthAutoChangeTimer
      autoChangeSelectYouthIndex(){
        if(this.youthAutoChangeTimer) clearInterval(this.youthAutoChangeTimer);
        this.youthAutoChangeTimer = setInterval(() => {
          this.selectYouthIndex = this.selectYouthIndex + 1;
        }, 4000)
      },

      // 绘制会员协会培训班统计表
      drawClassStatus(){
        // 设置图例
        const {series} = this.echartsPieOptions;
        const sourceSeries = series[0];
        sourceSeries.data = this.formateSquadDataPieData(); // 获取data数据
        let color = [
          '#68D8FE', '#FAC858', '#EE6666', '#90cb75', '#0b86fe', '#ff730d', '#0cd0db', '#756ff5', '#ffae0d'
          , '#ee7b74', '#91b6fa', '#0cb396', '#9096bc', '#d4b394', '#0aa3b5', '#be8663', '#e0719c', '#9db2b7'
        ];
        const options = Object.assign({}, this.echartsPieOptions, {
          series:[sourceSeries],
          color
        });

        // 开始画图
        const mapDom = document.getElementById("echart-pie");
        let class_status = echarts.init(mapDom);
        class_status.setOption(options);
        this.mapObj = class_status;
      },

      // 球队数据转化pie饼图数据
      formateSquadDataPieData(){
        const selectYouthIndex = this.selectYouthIndex;
        if(selectYouthIndex >= this.youthList.length){
          this.selectYouthIndex = 0;
        }
        // 获取球队列表中的一个
        return this.squadList[this.selectYouthIndex];
      },
    },
  };
</script>

<style lang="stylus" scoped>
  .row-content
    padding 1.25rem 0

    .row-title
      color #68D8FE
      font-weight 600
      font-size 16px
      margin-bottom 0.4rem
      display flex
      align-items center

    .data-wrapper
      display flex
      flex-wrap wrap

      .echart-class-status
        height 290px
        width 100%
</style>
